module.exports = __webpack_public_path__ + "static/media/D.d0034db2.png";